<template>
  <!-- :bodyStyle="{paddingTop:'10px'}" -->
  <a-card :bordered="false" :headStyle="{borderBottom:'0px',fontSize:'18px',paddingLeft:'24px'}">
    <search-page-view
      ref="table"
      rowKey="pftProId"
      :itemNames="['search_proId','search_proName','create_button',]"
      :columns="columns"
      :enableSearch="false"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
    >
      <a-form-item slot="search_proId" label="票付通商品ID" v-bind="formItemLayout">
        <a-input v-model="queryParams.pftProId" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="search_proName" label="商品名称" v-bind="formItemLayout">
        <a-input v-model="queryParams.pftProName" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="create_button">
        <a-button style="margin-left:15px" type="primary" @click="$refs.table.refresh(true)">查 询</a-button>
        <a-button style="margin-left:15px" @click="dialogVisible = true">手动同步</a-button>
      </a-form-item>
      <div slot="action" slot-scope="data">
        <a @click="onPreview(data.record)">预览</a>
      </div>
    </search-page-view>
    <a-modal title="手动同步" :visible="dialogVisible" width="550px" :footer="null" @cancel="handleCancel">
      <a-form-model :model="ruleForm" ref="ruleForm" :rules="rules"
                    :label-col="currentFormLayout.labelCol"
                    :wrapper-col="currentFormLayout.wrapperCol"
      >
        <a-form-model-item label="同步规则" prop="syncType">
          <a-radio-group name="radioGroup" v-model="ruleForm.syncType">
            <a-radio :value="0">全部同步</a-radio>
            <a-radio :value="1">指定商品同步</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="票付通商品ID" v-if="ruleForm.syncType==1" prop="productIds">
          <a-textarea v-model="ruleForm.productIds" :maxLength="300" placeholder="请输入票付通商品ID，一行一个，最多20个"
                      :rows="5"/>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 14, offset: 6 }">
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading">保存</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
import RouterSwitchHelper from '@/utils/helper/RouterSwitchHelper'

export default {
  name: 'SyncTicketPro',
  components: {},
  data() {
    var checkProIdStr = (rule, value, callback) => {
      setTimeout(() => {
        if (value.split(/\r?\n/).length > 20) {
          callback(new Error('票付通商品ID最多20个'))
        } else {
          callback()
        }
      }, 1000)
    }
    return {
      submitLoading: false,
      currentFormLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      ruleForm: {
        productIds: '',// 票付通商品ID 回车分割 ,
        syncType: undefined,// 同步类型 0全部同步 1按商品同步
        merchantId: this.$store.getters.userInfo.merchantId,// 运营商ID ,
        platformId: this.getPlatformConfig().platformId
      },
      rules: {
        syncType: [
          { required: true, message: '请选择同步规则', trigger: 'change' }
        ],
        productIds: [
          { required: true, message: '请输入票付通商品ID', trigger: 'blur' },
          { validator: checkProIdStr, trigger: 'blur' }
        ]
      },
      queryParams: {
        pftProId: '', //名称
        pftProName: ''
      },
      loadPromise: params => this.getListPromise(params),
      columns: [
        {
          title: '票付通ID',
          dataIndex: 'pftProId'
        },
        {
          title: '商品名称',
          dataIndex: 'pftProName'
        },
        {
          title: '类型',
          dataIndex: 'proTypeStr'
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '160px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      dialogVisible: false,
      formItemLayout: {
        labelCol: {
          xxl: { span: 6 },
          xl: { span: 7 },
          lg: { span: 8 },
          sm: { span: 9 },
          md: { span: 10 },
          xs: { span: 10 }
        },
        wrapperCol: {
          xxl: { span: 18 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 17 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 16 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 15 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 14 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 14 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      },
      submitFormData: ''
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'SyncTicketPro', title: '同步商品' },
      { name: 'SyncTicketOrder', title: '订单直连' },
      { name: 'RelAccount', title: '关联账号' }
    ])
  },
  methods: {
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getListPromise==', params)
      return this.getHttpServices().getProService().post('product/info/getPftThirdProInfoList', params)
    },
    handleCancel() {
      this.dialogVisible = false
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.submitLoading = true
      if (this.ruleForm.syncType == 0) {
        let merchantId = this.$store.getters.userInfo.merchantId// 运营商ID ,
        let platformId = this.getPlatformConfig().platformId
        this.getHttpServices().getServerApiService().post('api/pft/v1/all/save/' + merchantId + '/' + platformId).then(res => {
          this.getLogUtils().logWithTag('submitData', res)
          this.$message.success('全部同步成功')
          this.dialogVisible = false
          this.$refs.table.refresh(true)
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
      } else {
        this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
        delete this.submitFormData.syncType
        let arr = this.submitFormData.productIds.split(/\r?\n/)
        this.submitFormData.productIds = arr.join(',')
        this.getHttpServices().getServerApiService().post('api/pft/v1/section/save', this.submitFormData).then(res => {
          this.getLogUtils().logWithTag('submitData', res)
          this.$message.success('指定商品同步成功')
          this.dialogVisible = false
          this.$refs.table.refresh(true)
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
      }
    },
    //预览手机页面的详情
    onPreview(record) {
      const merchantId = this.$store.getters.userInfo.merchantId
      const character = 1
      const params = {
        p: `${character}_${merchantId}_${merchantId}`
      }
      let domainUrl = this.$store.getters.platformConfig.h5Url
      RouterSwitchHelper.toProductDetails(domainUrl, record.proId, record.proType, 0, params)
    }
  }

}
</script>
<style scoped lang="less">

</style>